import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EXPIRATION_PROMOTIONS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const deleteProductExpirationPromotionAction = createAsyncThunk(
    'price/deleteProductExpirationPromotionAction',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ EXPIRATION_PROMOTIONS_PATH }/${ id }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deleteProductExpirationPromotionSlice = createSlice({
    name: 'deleteProductExpirationPromotionSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(deleteProductExpirationPromotionAction.pending, () => STATE__API__STARTED);
        builder.addCase(deleteProductExpirationPromotionAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deleteProductExpirationPromotionAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deleteProductExpirationPromotionState = (state) => state.price.deleteProductExpirationPromotion;
export default deleteProductExpirationPromotionSlice.reducer;
